import { z } from 'zod';

import { messages } from './StepBackupCodes.messages';

export const schema = z.object({
    codesAreSaved: z.boolean().refine((val) => val, {
        message: messages.errorCodesAreSaved,
    }),
});
